import React, { useState } from 'react';

import { Typography } from '@mui/material'
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from 'react-bootstrap/Modal';
import Plantilla from './plantillas/Plantilla'

export default function ErrorModal({ error, onClose}) {
    if (!error.show) return null;

    return (
        <Modal show={error.show} onHide={onClose} centered style={{ height: "auto" }}>
            <Modal.Body className="home">
                <Row>
                    <Col>
                        <h3>
                            <strong>¡Ups!</strong>
                        </h3>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {!!error.message && <span dangerouslySetInnerHTML={{ __html: error.message }}></span>}
                        {!!error.message || <Plantilla id="ErrorInesperado" />}
                    </Col>
                </Row>
                {!!error.code &&
                    <Row>
                        <Col>
                            <Typography sx={{ my: 1 }} >
                                <span>Código: {error.code}</span>
                            </Typography>
                        </Col>
                    </Row>
                }

                <Row style={{ marginTop: "20px" }}>
                    <Col className="d-grid gap-2 portal">
                        <Button variant="primary" onClick={onClose}>
                            Aceptar
                        </Button>
                    </Col>
                </Row>

            </Modal.Body>
        </Modal>
    );
}

export const useErrorHandling = (defaultSerie, defaultNumber) => {
    defaultSerie = defaultSerie ? defaultSerie : '00000';
    defaultNumber = defaultNumber ? defaultNumber : '000';
    const defaultCode = `${defaultSerie}-${defaultNumber}`;

    const [error, setError] = useState({
        message: null,
        code: defaultCode,
        show: false,
        serie: defaultSerie,
    });

    const clearError = () => {
        setError({ message: null, code: defaultSerie, show: false });
    };

    const showErrorModal = (message, serie, numero) => {
        clearError();

        const code = (serie ?? defaultSerie) && numero ? `${serie ?? defaultSerie}-${numero}` : defaultCode;

        setError({ message, code, show: true });
    };

    return { error, clearError, showErrorModal };
};

